import { useEffect, useState } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { LangProvider } from "@/i18n/LangContext";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import About from "@/components/site/About";
import Yatra from "@/components/site/Yatra";
import Offerings from "@/components/site/Offerings";
import Events from "@/components/site/Events";
import Gallery from "@/components/site/Gallery";
import Stillness from "@/components/site/Stillness";
import Testimonials from "@/components/site/Testimonials";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import Admin from "@/components/site/Admin";

const THEMES = ["baby-pink", "early-sky"];

const Home = ({ theme }) => (
  <>
    <main>
      <Hero />
      <Marquee />
      <About />
      <Yatra />
      <Offerings />
      <Events />
      <Gallery />
      <Stillness />
      <Testimonials />
      <Contact theme={theme} />
    </main>
    <Footer />
  </>
);

function App() {
  const [theme, setTheme] = useState(() => {
    const saved = localStorage.getItem("maprem-theme");
    return THEMES.includes(saved) ? saved : "baby-pink";
  });

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("maprem-theme", theme);
  }, [theme]);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    window.__lenis = lenis;
    let rafId;
    const raf = (t) => {
      lenis.raf(t);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  const toggleTheme = () =>
    setTheme((t) => THEMES[(THEMES.indexOf(t) + 1) % THEMES.length]);

  return (
    <div className="themed grain min-h-screen" style={{ backgroundColor: "var(--bg-canvas)", color: "var(--text-primary)" }}>
      <LangProvider>
        <BrowserRouter>
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <Navbar theme={theme} onToggleTheme={toggleTheme} />
                  <Home theme={theme} />
                </>
              }
            />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
      </LangProvider>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "var(--bg-surface-elevated)",
            color: "var(--text-primary)",
            border: "1px solid var(--border-delicate)",
          },
        }}
      />
    </div>
  );
}

export default App;
